import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const LockOpenRightIcon = React.forwardRef<SVGSVGElement, IconProps>(function LockOpenRightIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <mask id="a" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}><path fill="currentColor" d="M0 0h24v24H0z"/></mask><g mask="url(#a)"><path fill="currentColor" d="M13.41 16.41Q14 15.82 14 15t-.59-1.41A2 2 0 0 0 12 13q-.82 0-1.41.59A2 2 0 0 0 10 15q0 .82.59 1.41T12 17t1.41-.59M6 22q-.82 0-1.41-.59A2 2 0 0 1 4 20V10q0-.82.59-1.41A2 2 0 0 1 6 8h7V6q0-2.08 1.46-3.54Q15.93 1 18 1t3.54 1.46T23 6h-2q0-1.25-.87-2.12A3 3 0 0 0 18 3q-1.25 0-2.12.88A3 3 0 0 0 15 6v2h3q.82 0 1.41.59T20 10v10q0 .82-.59 1.41A2 2 0 0 1 18 22z"/></g>
        </IconBase>
    );
});
